import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MalawiFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15472'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15472)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99935 8.40003C11.8403 8.40003 13.3327 6.9375 13.3327 5.13337C13.3327 3.32924 11.8403 1.8667 9.99935 1.8667C8.1584 1.8667 6.66602 3.32924 6.66602 5.13337C6.66602 6.9375 8.1584 8.40003 9.99935 8.40003Z'
					fill='#E42038'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='#E42038'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#47B849'
				/>
			</g>
		</svg>
	);
};

export default MalawiFlagIcon;
